import { render } from "./BadgeStato.vue?vue&type=template&id=899009f0&ts=true"
import script from "./BadgeStato.vue?vue&type=script&lang=ts"
export * from "./BadgeStato.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__